import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getMiniPlayerData as getMiniPlayerDataAction } from 'redux/modules/navbar';

import Breakpoints from 'lib/Breakpoints';
import { ENABLE_MINI_TEASE, SHOW_MINI_TEASE_ONLY_ON_COVER } from 'lib/brandFeatures.json';
import { getFeatureConfigForBrand } from 'lib/getFeatureStatus';
import { miniPlayerTease as miniPlayerTeasePropType } from 'lib/CustomPropTypes';

import MsnbcTVE from './Tease/MsnbcTVE';
import NewsNow from './Tease/NewsNow';
import { WatchNowTease } from './Tease/WatchNow';
import TodayAllDay from './Tease/TodayAllDay';

const mapStateToProps = ({
  navbar,
  router,
  shared,
}) => ({
  miniPlayerData: navbar.miniPlayerData,
  pageView: shared.pageView,
  path: router.path,
  vertical: shared.vertical,
});

const mapActionToProps = (dispatch) => ({
  getMiniPlayerData: (vertical) => dispatch(getMiniPlayerDataAction(vertical)),
});

class MiniPlayerTease extends React.Component {
  static propTypes = {
    getMiniPlayerData: PropTypes.func,
    miniPlayerLoaded: PropTypes.bool,
    miniPlayerData: PropTypes.oneOfType([
      PropTypes.string,
      miniPlayerTeasePropType,
    ]),
    useLocalTease: PropTypes.bool,
    onShowTease: PropTypes.func,
    pageView: PropTypes.string,
    path: PropTypes.string,
    vertical: PropTypes.string.isRequired,
  };

  static defaultProps = {
    getMiniPlayerData: Function.protoype,
    miniPlayerLoaded: false,
    miniPlayerData: {
      showTease: false,
    },
    useLocalTease: false,
    onShowTease: Function.prototype,
    pageView: null,
    path: null,
  };

  componentDidMount() {
    const { miniPlayerLoaded } = this.props;
    if (!miniPlayerLoaded) {
      const { getMiniPlayerData, vertical } = this.props;
      // Feature enabled
      const enabled = this.isEnabled();
      // Feature restricted to cover
      const onlyOnCover = this.isOnlyOnCover();
      // Fetch mini player configuration data
      if (enabled && (!onlyOnCover || (onlyOnCover && this.isCover()))) {
        getMiniPlayerData(vertical);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      miniPlayerData: {
        showTease: wasShown,
      },
    } = prevProps;

    const {
      miniPlayerData: {
        showTease: isShown,
      },
    } = this.props;

    if (wasShown === false && isShown === true && this.shouldRender()) {
      const { onShowTease } = this.props;
      onShowTease();
    }
  }

  /**
   * Get enabled configuration value
   */
  isEnabled = () => {
    const { vertical } = this.props;
    return getFeatureConfigForBrand(ENABLE_MINI_TEASE, vertical);
  }

  /**
   * Get placement configuration value
   */
  isOnlyOnCover = () => {
    const { vertical } = this.props;
    return getFeatureConfigForBrand(SHOW_MINI_TEASE_ONLY_ON_COVER, vertical);
  }

  isCover = () => {
    const { pageView, path } = this.props;
    return pageView === 'front' && path === '/';
  }

  shouldRender = () => {
    if (!this.isEnabled()) {
      return false;
    }

    const { miniPlayerData } = this.props;
    if (miniPlayerData) {
      const {
        pageView,
        path,
      } = this.props;

      const {
        brand,
        includedPageTypes,
        excludedPages,
        showTease,
      } = miniPlayerData;

      const isCover = this.isCover();
      const onlyOnCover = this.isOnlyOnCover();

      if (includedPageTypes || excludedPages) {
        // Cover Mobile
        if (isCover && typeof includedPageTypes.coverMobile !== 'undefined' && Breakpoints.isS()) {
          return includedPageTypes.coverMobile;
        }
        // Cover
        if (isCover && typeof includedPageTypes.cover !== 'undefined') {
          return includedPageTypes.cover;
        }
        // Front / Article
        if (includedPageTypes[pageView]) {
          // Excluded pages
          const excludedArray = (typeof excludedPages === 'string' && excludedPages.split(/\n|\n\r/)) || [];
          return !excludedArray.includes(path);
        }
      } else if (typeof brand !== 'undefined' && onlyOnCover && isCover) {
        // News and Today only show on cover
        return showTease;
      }
    }
    return false;
  }

  render() {
    if (!this.shouldRender()) {
      return null;
    }

    const {
      miniPlayerData,
      miniPlayerData: {
        brand,
      },
      useLocalTease,
      pageView,
      path,
    } = this.props;

    let TeaseComponent;

    if (brand === 'MsnbcTVE') {
      TeaseComponent = MsnbcTVE;
    } else if (brand === 'newsspecialreport') {
      TeaseComponent = NewsNow;
    } else if (brand === 'newsnow') {
      if (useLocalTease) {
        TeaseComponent = WatchNowTease;
      } else {
        TeaseComponent = NewsNow;
      }
    } else if (brand === 'todayallday') {
      TeaseComponent = TodayAllDay;
    } else {
      return null;
    }

    return (
      <TeaseComponent
        {...miniPlayerData}
        pageView={pageView}
        path={path}
      />
    );
  }
}

export default connect(mapStateToProps, mapActionToProps)(
  MiniPlayerTease,
);
